export const safeAwaitApiResponse = async <TApiResponse>(apiResponse: Promise<TApiResponse>): Promise<TApiResponse> => {
    try {
        return await apiResponse
    } catch {
        return {} as TApiResponse
    }
}
